export const whiteBackground = "var(--BaseCss_whiteBackground)";
export const primaryColor = "var(--BaseCss_primaryColor)";
export const primaryBrighterColor = "var(--BaseCss_primaryBrighterColor)";
export const primaryDark = "var(--BaseCss_primaryDark)";
export const primaryDarkest = "var(--BaseCss_primaryDarkest)";
export const blueColor = "var(--BaseCss_blueColor)";
export const backgroundColor = "var(--BaseCss_backgroundColor)";
export const fontColor = "var(--BaseCss_fontColor)";
export const inputBackgroundColor = "var(--BaseCss_inputBackgroundColor)";
export const inputBorderColor = "var(--BaseCss_inputBorderColor)";
export const errorColor = "var(--BaseCss_errorColor)";
export const completeColor = "var(--BaseCss_completeColor)";
export const inverseFontColor = "var(--BaseCss_inverseFontColor)";
export const primaryIconColor = "var(--BaseCss_primaryIconColor)";
export const lightBorderColor = "var(--BaseCss_lightBorderColor)";
export const strokeSize = "var(--BaseCss_strokeSize)";
export const darkGrey = "var(--BaseCss_darkGrey)";
export const black = "var(--BaseCss_black)";
export const white = "var(--BaseCss_white)";
export const yellow = "var(--BaseCss_yellow)";
export const yellowDarker = "var(--BaseCss_yellowDarker)";
export const darkBlueTheme = "BaseCss_darkBlueTheme";
export const h1XLarge = "BaseCss_h1XLarge";
export const smallText = "BaseCss_smallText";
export const textAlignCenter = "BaseCss_textAlignCenter";
export const absolute = "BaseCss_absolute";
export const relative = "BaseCss_relative";
export const absoluteFill = "BaseCss_absoluteFill";
export const rowStartBetween = "BaseCss_rowStartBetween";
export const rowCenterEnd = "BaseCss_rowCenterEnd";
export const rowCenterStart = "BaseCss_rowCenterStart";
export const rowCenterCenterWrap = "BaseCss_rowCenterCenterWrap";
export const rowCenterCenter = "BaseCss_rowCenterCenter";
export const row = "BaseCss_row";
export const wrap = "BaseCss_wrap";
export const rowCenterBetween = "BaseCss_rowCenterBetween";
export const columnCenterBetween = "BaseCss_columnCenterBetween";
export const column = "BaseCss_column";
export const columnCenter = "BaseCss_columnCenter";
export const childM5M0 = "BaseCss_childM5M0";
export const childM10M0 = "BaseCss_childM10M0";
export const childM15M0 = "BaseCss_childM15M0";
export const childM20M0 = "BaseCss_childM20M0";
export const childM0M5 = "BaseCss_childM0M5";
export const childM0M10 = "BaseCss_childM0M10";
export const childM0M20 = "BaseCss_childM0M20";
export const childPL10 = "BaseCss_childPL10";
export const icon20px = "BaseCss_icon20px";
export const icon25px = "BaseCss_icon25px";
export const icon30px = "BaseCss_icon30px";
export const m5 = "BaseCss_m5";
export const m10 = "BaseCss_m10";
export const m20 = "BaseCss_m20";
export const p10 = "BaseCss_p10";
export const p5 = "BaseCss_p5";
export const icon40px = "BaseCss_icon40px";
export const icon50px = "BaseCss_icon50px";
export const icon60px = "BaseCss_icon60px";
export const blackTheme = "BaseCss_blackTheme";
export const errorBorder = "BaseCss_errorBorder";
export const successBorder = "BaseCss_successBorder";
export const whiteIcon = "BaseCss_whiteIcon";
